import { useTheme } from "./ThemeContext";
import { BRAND } from "./data";

export const LogoMark = ({ className = "", variant = "icon" }) => {
  const { theme } = useTheme();

  if (variant === "full") {
    const src = theme === "dark" ? BRAND.logoDark : BRAND.logoLight;
    return (
      <img
        src={src}
        alt="Brainstem App Solutions"
        className={className}
        style={{ objectFit: "contain" }}
      />
    );
  }

  return (
    <img
      src="/brain-icon.png"
      alt="Brainstem"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
};
